export default function isDashboardApp(location = window.location) {
  // E.g. localhost:3000 or dashboard.watershedclimate.com or proxy.localhost:3000
  if (!process.env.NEXT_PUBLIC_DASHBOARD_HOST) {
    return false;
  }
  const publicDashboardHost = new URL(process.env.NEXT_PUBLIC_DASHBOARD_HOST);
  return location.host.includes(publicDashboardHost.host);
}
